import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getColour, getParticularPage, getNext, getPrevious, createColour, updateColour, handleSearch } from "./thunk";

const initialState = {
  colours: [],
  edit: false,
  colour: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingColour: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    isActive: true,
  },

  activeColourId: null,
};

export const colourSlice = createSlice({
  name: "colour",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    colourEditSuccess: (state, action) => {
      state.edit = true;
      state.colour = state.colours.find((colour) => colour.id === action.payload);
      state.formData = state.colours.find((colour) => colour.id === action.payload);
      state.activeColourId = action.payload;
    },
    resetColourForm: (state, action) => {
      if (action.payload) {
        // if edit is true, reset to colour data
        state.formData = state.colour;
      } else {
        state.formData = initialState.formData; // if edit is false, reset to initial state
        state.activeColourId = null;
      }
    },
    // New reducers for form persistence
    saveColourForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllColour: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingColour = false;
      state.colour = null;
      state.formData = initialState.formData;
      state.activeColourId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createColour.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createColour.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
      state.formData = initialState.formData;
      state.activeColourId = null;
    });
    builder.addCase(createColour.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateColour.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateColour.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.formData = initialState.formData;
      state.activeColourId = null;
      state.edit = false;
    });
    builder.addCase(updateColour.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(getColour.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingColour = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getColour.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingColour = false;
        state.colours = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getColour.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingColour = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  colourEditSuccess,
  saveColourForm,
  resetColourForm,
  clearColourForm,
  clearAllColour,
} = colourSlice.actions;

export default colourSlice.reducer;
